import React from "react";
import { motion } from "framer-motion";
import "./About.css";

function About() {
  return (
    <section id="about" className="about-section">
      <motion.div
        className="section-title"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <h1>Get to know Aboud.</h1>
      </motion.div>

      <div className="about-container">
        {/* Profile Image Animation */}
        <motion.img
          src="/images/aboudpic.png"
          className="about-image"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
          viewport={{ once: true }}
        />

        <motion.div
          className="about-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <p>
            I am a <span className="highlight">Computer Engineer</span>{" "}
            driven by a passion to make a meaningful impact on people's
            lives through tech. My interests encompass multiple areas of
            programming, including investigating{" "}
            <span className="highlight">human-computer interactions</span>,
            advancing <span className="highlight">machine learning and AI</span>,
            and exploring in{" "}
            <span className="highlight">enterprise computing and the mainframe</span>. I also
            enjoy <span className="highlight">building applications</span> that
            simplify everyday tasks and improve overall efficiency, making all our lives a little easier.
          </p>

          <motion.h3
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            Technologies I’ve been working with:
          </motion.h3>

          <motion.ul
            className="technologies-list"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <li>
              <img src="/images/about_arrow.png" alt='arrow' className="arrow-icon" />
              Python
            </li>
            <li>
              <img src="/images/about_arrow.png" alt='arrow' className="arrow-icon" />
              Java
            </li>
            <li>
              <img src="/images/about_arrow.png" alt='arrow' className="arrow-icon" />
              C++
            </li>
            <li>
              <img src="/images/about_arrow.png" alt='arrow' className="arrow-icon" />
              C#
            </li>
            <li>
              <img src="/images/about_arrow.png" alt='arrow' className="arrow-icon" />
              React JS
            </li>
            <li>
              <img src="/images/about_arrow.png" alt='arrow' className="arrow-icon" />
              Swift
            </li>
          </motion.ul>
        </motion.div>
      </div>
    </section>
  );
}

export default About;
